module.exports = __webpack_public_path__ + "static/img/b12.103764d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b12.png
// module id = fkdg
// module chunks = 1